import { render } from "./sms_credits.vue?vue&type=template&id=55b22380&scoped=true"
import script from "./sms_credits.vue?vue&type=script&lang=js"
export * from "./sms_credits.vue?vue&type=script&lang=js"

import "./sms_credits.vue?vue&type=style&index=0&id=55b22380&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b22380"]])

export default __exports__